import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';
import type {
  AuthResponse,
  LoginCredentials,
  RegisterCredentials,
  RegisterResponse,
} from '@/types/auth';

export const useLogin = () => {
  return useMutation<AuthResponse, Error, LoginCredentials>({
    mutationFn: async (credentials) => {
      const { data } = await apiClient.post('/auth/login', credentials);
      return data;
    },
  });
};

export const useRegister = () => {
  return useMutation<RegisterResponse, Error, RegisterCredentials>({
    mutationFn: async (credentials) => {
      const { data } = await apiClient.post('/auth/register', credentials);
      return data;
    },
  });
};
